import { useId } from "react";
import { CATEGORIES, CONDITIONS, STATUS_LABELS } from "@/lib/site";

const inputCls = "fundio-input";
const labelCls = "fundio-field-label";

export default function ItemFields({ form, set, canPublish = true }) {
  const id = useId();
  const upd = (k) => (e) => set({ ...form, [k]: e.target.value });
  const statusKeys = canPublish ? Object.keys(STATUS_LABELS) : ["draft", "review"];
  return (
    <div className="fundio-fields">
      <div>
        <label htmlFor={`${id}-title`} className={labelCls}>Titel *</label>
        <input id={`${id}-title`} required data-testid="field-title" value={form.title} onChange={upd("title")} className={inputCls} placeholder="z.B. Eichen-Kommode vintage" />
      </div>

      <div className="fundio-field-row">
        <div>
          <label htmlFor={`${id}-category`} className={labelCls}>Kategorie</label>
          <select id={`${id}-category`} data-testid="field-category" value={form.category} onChange={upd("category")} className={inputCls}>
            {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <label htmlFor={`${id}-condition`} className={labelCls}>Zustand</label>
          <select id={`${id}-condition`} data-testid="field-condition" value={form.condition} onChange={upd("condition")} className={inputCls}>
            {CONDITIONS.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <label htmlFor={`${id}-price`} className={labelCls}>Preis (CHF)</label>
          <input id={`${id}-price`} data-testid="field-price" type="number" inputMode="decimal" step="any" value={form.price ?? ""} onChange={(e) => set({ ...form, price: e.target.value === "" ? null : Number(e.target.value) })} className={inputCls} placeholder="z.B. 80" />
        </div>
      </div>

      <div>
        <label htmlFor={`${id}-description`} className={labelCls}>Beschreibung</label>
        <textarea id={`${id}-description`} data-testid="field-description" value={form.description} onChange={upd("description")} rows={4} className={inputCls} placeholder="Beschreibe dein Fundstück …" />
      </div>

      <div className="fundio-field-row fundio-field-row--two">
        <div>
          <label htmlFor={`${id}-seo-title`} className={labelCls}>SEO-Titel</label>
          <input id={`${id}-seo-title`} data-testid="field-seo-title" value={form.seo_title} onChange={upd("seo_title")} className={inputCls} />
        </div>
        <div>
          <label htmlFor={`${id}-whatsapp`} className={labelCls}>WhatsApp-Text</label>
          <input id={`${id}-whatsapp`} data-testid="field-whatsapp" value={form.whatsapp_text} onChange={upd("whatsapp_text")} className={inputCls} />
        </div>
      </div>

      <div>
        <label htmlFor={`${id}-seo-description`} className={labelCls}>SEO-Beschreibung</label>
        <input id={`${id}-seo-description`} data-testid="field-seo-description" value={form.seo_description} onChange={upd("seo_description")} className={inputCls} maxLength={160} />
      </div>

      <div>
        <label htmlFor={`${id}-status`} className={labelCls}>Status</label>
        <select id={`${id}-status`} data-testid="field-status" value={statusKeys.includes(form.status) ? form.status : "review"} onChange={upd("status")} className={inputCls}>
          {statusKeys.map((s) => <option key={s} value={s}>{STATUS_LABELS[s]}</option>)}
        </select>
        {!canPublish && <p className="mt-2 text-sm fundio-muted">Du kannst Entwürfe vorbereiten. Veröffentlichen übernimmt ein Mitarbeiter.</p>}
      </div>
    </div>
  );
}
